import React, { useEffect, useContext }  from 'react';
import { withRouter } from "react-router-dom";
import { UserContext } from "../userContext";
import Login from '../components/login';
import Navbar from '../components/navbar';

const Home = ({history}) => {
    const { user } = useContext(UserContext).user;

    useEffect(() => {
    if(user) history.push('/dashboard')
    }, [user, history])

    return (
    <>
    <Navbar />
        <div className="home">
            <Login />
        </div>
    </>
      );
}
 
export default withRouter(Home);